import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-20 pb-8 px-4 overflow-hidden" data-id="element-143">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-500/20 blur-[120px] rounded-full pointer-events-none" data-id="element-144" />

      <div className="max-w-3xl mx-auto text-center relative z-10 w-full" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 font-bold text-sm mb-4" data-id="element-146">
          <span data-id="element-147">💛</span> NUEVO NIVEL™
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        type: 'spring',
        stiffness: 120
      }} className="mb-5 flex justify-center" data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/4FqpDKPQAtVB4VQoSgJndE/2.png" alt="Combo Nuevo Nivel TDAH — libro completo, guías y bonos para padres" className="w-44 sm:w-52 md:w-60 aspect-square object-contain drop-shadow-[0_15px_45px_rgba(251,191,36,0.25)]" data-id="element-149" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight mb-3" data-id="element-150">
          Todo lo que necesitás para{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-amber-500" data-id="element-151">
            acompañar a tu hijo.
          </span>{' '}
          <span className="text-slate-300" data-id="element-152">Listo. Desde hoy.</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-sm sm:text-base text-slate-300 mb-4 max-w-xl mx-auto" data-id="element-153">
          <span className="font-bold text-amber-400" data-id="element-154">
            El sistema N°1 de apoyo para padres de niños con TDAH.
          </span>{' '}
          Herramientas y estrategias listas para usar. Sin improvisar, sin
          agotarte.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-2 mb-5" data-id="element-155">
          <div className="flex items-center gap-1.5 bg-slate-900 px-3 py-1.5 rounded-lg border border-slate-800 text-xs font-semibold text-slate-300" data-id="element-156">
            <FileText className="w-3.5 h-3.5 text-amber-400" data-id="element-157" /> 100% PDF
          </div>
          <div className="flex items-center gap-1.5 bg-slate-900 px-3 py-1.5 rounded-lg border border-slate-800 text-xs font-semibold text-slate-300" data-id="element-158">
            <Zap className="w-3.5 h-3.5 text-amber-400" data-id="element-159" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-1.5 bg-slate-900 px-3 py-1.5 rounded-lg border border-slate-800 text-xs font-semibold text-slate-300" data-id="element-160">
            <Layers className="w-3.5 h-3.5 text-amber-400" data-id="element-161" /> Todos los niveles
          </div>
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        type: 'spring',
        stiffness: 200
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToPricing} className="w-full sm:w-auto text-center bg-gradient-to-r from-amber-400 to-amber-500 text-slate-950 text-lg md:text-xl font-black py-4 px-8 rounded-full shadow-[0_0_40px_rgba(251,191,36,0.4)] hover:shadow-[0_0_60px_rgba(251,191,36,0.6)] transition-all mb-4 inline-flex items-center justify-center gap-3 mx-auto" data-id="element-162">
          💛 → QUIERO MI COMBO AHORA
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs sm:text-sm text-slate-400 font-medium" data-id="element-163">
          <span className="flex items-center gap-1.5" data-id="element-164">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-165" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-166">
            <Lock className="w-4 h-4 text-green-400" data-id="element-167" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-168">
            <CreditCard className="w-4 h-4 text-blue-400" data-id="element-169" /> Mercado Pago
          </span>
        </motion.div>
      </div>
    </section>;
}